<template>
  <div>
    <el-form size="mini">
      <!-- <el-form-item
        label="Is Costco Format (Hardt if not checked)"
        prop="isForCostco"
      >
        <el-switch v-model="form.isForCostco"></el-switch>
      </el-form-item>
      <el-form-item
        label="Is for Canada (US if not checked)"
        prop="isCanadian"
      >
        <el-switch v-model="form.isCanadian"></el-switch>
      </el-form-item> -->
      <el-form-item>
        <el-select
          v-model="reportType"
          class="select"
          clearable
          :placeholder="$t('reports.pleaseSelectType')"
          :loading="loading"
          @change="change"
          size="large"
          style="width:270px;"
        >
          <el-option
            label="CDN Costco Non Warranty / Hardt"
            :value="0"
          ></el-option>
          <el-option
            label="CDN Costco Non Warranty / Costco"
            :value="1"
          ></el-option>
          <el-option
            label="USA Costco Non Warranty / Hardt"
            :value="2"
          ></el-option>
          <el-option
            label="USA Costco Non Warranty / Costco"
            :value="3"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-collapse>
        <el-collapse-item>
          <template slot="title">
              <p class="custome-collapse-color">
                  {{$t('reports.parameters')}} <i class="header-icon el-icon-info"></i>
              </p>
          </template>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item
                :label="$t('reports.dateFromAcceptedDate')"
                prop="dateFrom"
              >
                <el-date-picker
                  v-model="form.dateFrom"
                  type="date"
                  style="width:100%;"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                :label="$t('common.serviceCompany')"
                prop="serviceCompany"
              >
                <el-input v-model="form.serviceCompany"></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('common.customer')"
                prop="customerId"
              >
                <customer-selector v-model="form.customerId" />
              </el-form-item>
              <el-form-item
                :label="$t('common.claimNumber')"
                prop="claimNumber"
              >
                <el-input v-model="form.claimNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('reports.dateToAcceptedDate')"
                prop="dateTo"
              >
                <el-date-picker
                  v-model="form.dateTo"
                  type="date"
                  style="width:100%;"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                :label="$t('common.status')"
                prop="status"
              >
                <el-select
                  v-model="form.status"
                  style="width:100%;"
                >
                  <el-option
                    :label="$t('common.new')"
                    value="1"
                  ></el-option>
                  <el-option
                    :label="$t('common.acceptAndProcess')"
                    value="2"
                  ></el-option>
                  <el-option
                    :label="$t('common.moreinfoRequired')"
                    value="3"
                  ></el-option>
                  <el-option
                    :label="$t('common.paid')"
                    value="6"
                  ></el-option>
                  <el-option
                    :label="$t('common.rejected')"
                    value="4"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('common.product')"
                prop="productId"
              >
                <product-selector v-model="form.productId"></product-selector>
              </el-form-item>
              <el-form-item
                :label="$t('reports.sortBy')"
                prop="sortBy"
              >
                <el-select
                  v-model="form.sortBy"
                  style="width:100%;"
                >
                  <el-option
                    :label="$t('reports.customerNumber')"
                    value="0"
                  ></el-option>
                  <el-option
                    :label="$t('common.customerName')"
                    value="1"
                  ></el-option>
                  <el-option
                    :label="$t('common.acceptedDate')"
                    value="2"
                  ></el-option>
                  <el-option
                    :label="$t('common.address')"
                    value="3"
                  ></el-option>
                  <el-option
                    :label="$t('common.city')"
                    value="4"
                  ></el-option>
                  <el-option
                    :label="$t('reports.province')"
                    value="5"
                  ></el-option>
                  <el-option
                    :label="$t('common.region')"
                    value="6"
                  ></el-option>
                  <el-option
                    :label="$t('common.regional')"
                    value="7"
                  ></el-option>
                  <el-option
                    :label="$t('reports.company')"
                    value="8"
                  ></el-option>
                  <el-option
                    :label="$t('common.claimNumber')"
                    value="9"
                  ></el-option>
                  <el-option
                    :label="$t('common.invoiceNumber')"
                    value="10"
                  ></el-option>
                  <el-option
                    :label="$t('common.workOrder')"
                    value="11"
                  ></el-option>
                  <el-option
                    :label="$t('reports.dateOfCompletion')"
                    value="12"
                  ></el-option>
                  <el-option
                    :label="$t('common.model')"
                    value="13"
                  ></el-option>
                  <el-option
                    :label="$t('common.labor')"
                    value="16"
                  ></el-option>
                  <el-option
                    :label="$t('common.parts')"
                    value="18"
                  ></el-option>
                  <el-option
                    :label="$t('common.freight')"
                    value="19"
                  ></el-option>
                  <el-option
                    :label="$t('common.total')"
                    value="20"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('reports.sortDescending')"
                prop="sortDesc"
              >
                <el-switch v-model="form.sortDesc"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>

        </el-collapse-item>
      </el-collapse>
      <br />
      <el-button
        :loading="loading"
        type="primary"
        @click="generateReport"
      >{{$t('common.generate')}}</el-button>
      <el-button :loading="loading"
                 @click="exportExcel"
                 v-if="claims.length > 0">{{$t('reports.exportToExcel')}}</el-button>
    </el-form>
    <br />
    <el-scrollbar v-if="claims.length > 0">
      <table>
        <thead>
            <tr>
                <th>{{$t('reports.claimCreationDate')}}</th>
                <th>{{$t('reports.dateOfCompletition')}}</th>
                <th>{{$t('common.acceptedDate')}}</th>
                <th>{{$t('reports.daysToInvoice')}}</th>
                <th>{{$t('reports.customerNo')}}</th>
                <th>{{$t('common.customerName')}}</th>
                <th>{{$t('common.address')}}</th>
                <th>{{$t('common.city')}}</th>
                <th>{{$t('reports.province')}}</th>
                <th>{{$t('common.region')}}</th>
                <th>{{$t('common.regional')}}</th>
                <th>{{$t('reports.company')}}</th>
                <th>{{$t('common.claimNumber')}}</th>
                <th>{{$t('common.invoiceNumber')}}</th>
                <th>{{$t('common.workOrder')}}</th>
                <th>{{$t('common.serialNumber')}}</th>
                <th>{{$t('common.model')}}</th>
                <th>{{$t('common.repairCode')}}</th>
                <th>{{$t('reports.repairDescription')}}</th>
                <th>{{$t('reports.laborHours')}}</th>
                <th>{{$t('common.labor')}}</th>
                <th>{{$t('reports.travelTruckMileage')}}</th>
                <th>{{$t('reports.parts')}}</th>
                <th>{{$t('reports.freight')}}</th>
                <th v-if="form.isCanadian">HST 13%</th>
                <th>{{$t('reports.total')}}</th>
                <th v-if="form.isForCostco">{{$t('reports.laborRegularHours')}}</th>
                <th v-if="form.isForCostco">{{$t('reports.laborRegularTotal')}}</th>
                <th v-if="form.isForCostco">{{$t('reports.laborOvertimeHours')}}</th>
                <th v-if="form.isForCostco">{{$t('reports.laborOvertimeTotal')}}</th>
                <th v-if="form.isForCostco">{{$t('common.misc')}}</th>
            </tr>
        </thead>

        <tbody>
          <template v-for="claim in claims">
              <tr :key="claim.id"
                  style="cursor: pointer;"
                  v-on:click="chooseAction(claim.id, claim.status)">
                  <td>{{claim.claimCreationDate | date}}</td>
                  <td>{{claim.dateWorkCompleted | date}}</td>
                  <td>{{claim.acceptedDate | date}}</td>
                  <td>{{claim.daysToInvoice}}</td>
                  <td>{{claim.storeNumber}}</td>
                  <td>{{claim.customerName}}</td>
                  <td>{{claim.street}}</td>
                  <td>{{claim.city}}</td>
                  <td>{{claim.code}}</td>
                  <td>{{claim.region}}</td>
                  <td>{{claim.regional}}</td>
                  <td>{{claim.companyName}}</td>
                  <td>{{claim.claimNumber}}</td>
                  <td>{{claim.invoiceNumber}}</td>
                  <td>{{claim.serviceWorkOrder}}</td>
                  <td>{{claim.serialNumber}}</td>
                  <td>{{claim.model}}</td>
                  <td>{{claim.firstRepair ? claim.firstRepair.code : ''}}</td>
                  <td>{{claim.firstRepair ? claim.firstRepair.description : ''}}</td>
                  <td>{{claim.laborHours}}</td>
                  <td>{{claim.laborTotal | money}}</td>
                  <td>{{claim.travelTruckMileage | money}}</td>
                  <td>{{claim.partsTotal | money}}</td>
                  <td>{{claim.freight | money }}</td>
                  <td v-if="form.isCanadian">{{claim.gst | money}}</td>
                  <td>{{claim.total | money}}</td>
                  <td v-if="form.isForCostco">{{claim.laborRegularHours}}</td>
                  <td v-if="form.isForCostco">{{claim.laborRegularTotal | money}}</td>
                  <td v-if="form.isForCostco">{{claim.laborOvertimeHours}}</td>
                  <td v-if="form.isForCostco">{{claim.laborOvertimeTotal | money}}</td>
                  <td v-if="form.isForCostco">{{claim.tax | money}}</td>
              </tr>
            <tr
              v-for="code in claim.restRepairs"
              :key="code.id"
            >
              <td colspan="15"></td>
              <td>{{code.code}}</td>
              <td>{{code.description}}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </el-scrollbar>
    <el-alert
      v-if="showNoDataMessage"
      :title="$t('reports.noDataFound')"
      type="error"
    ></el-alert>
    <el-button :loading="loading"
               @click="generateFullReport"
               v-if="showButton">{{$t('reports.viewMore')}}</el-button>
    <el-dialog
      :title="$t('common.pleaseChoose')"
      :visible.sync="chooseActionVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <span>{{$t('common.whatYouWantToDo')}}</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="chooseActionVisible = false">{{$t('common.nothing')}}</el-button>
        <el-button
          type="primary"
          @click="viewClaim(claimId)"
        >{{$t('common.view')}}</el-button>
        <el-button type="primary"
                   @click="editClaim(claimId)"
                   :disabled="!canBeEdited">{{$t('reports.edit')}}</el-button>
      </span>
    </el-dialog>
    <create-update-claim-dialog
      :claimId="claimToEdit"
      :visible="updateClaimVisible"
      @dialogClosed="updateClaimFinished"
      @showClaimPreview="showClaimPreview"
    ></create-update-claim-dialog>
    <preview-claim-dialog
      :claimId="claimToView"
      :visible="previewClaimVisible"
      @dialogClosed="previewClaimFinished"
      @editClaim="editClaim"
      @claimPublished="claimPublished"
    ></preview-claim-dialog>
  </div>
</template>

<script>
import api from "../api";
import { ProductSelector, CustomerSelector} from "@/app/shared/components";
import CreateUpdateClaimDialog from "@/app/claims/components/CreateUpdateClaimDialog";
import PreviewClaimDialog from "@/app/claims/components/PreviewClaimDialog";
export default {
  name: "costco-report",
  components: {
    ProductSelector,
    CreateUpdateClaimDialog,
    PreviewClaimDialog,
    CustomerSelector
  },
  data() {
    return {
      form: {
        isCanadian: true,
        isForCostco: false
      },
      showButton: false,
      claims: [],
      loading: false,
      showNoDataMessage: false,
      isFirst50Items: true,
      chooseActionVisible: false,
      claimId: 0,
      claimStatus: null,
      updateClaimVisible: false,
      previewClaimVisible: false,
      claimToView: undefined,
      claimToEdit: undefined,
      reportType: 0
    };
  },
  watch: {
    form: {
      deep: true,
      handler: function(val) {
        this.claims = [];
      }
    }
  },
  computed: {
    canBeEdited() {
      return this.claimStatus === 0 || this.claimStatus === 3;
    }
  },
  methods: {
    generateFullReport() {
      this.loading = true;
      this.isFirst50Items = false;
      api.getClaims(this.form, this.isFirst50Items).then(response => {
        this.loading = false;
        this.showButton = false;
        this.claims = this.claims.concat(response.data);
        this.isFirst50Items = true;
      });
    },
    generateReport() {
      this.showNoDataMessage = false;
      this.loading = true;
      api.getClaims(this.form, this.isFirst50Items).then(response => {
        this.loading = false;
        if (response.data.length === 0) {
          this.showNoDataMessage = true;
        }
        this.claims = response.data;
        if (response.data[0]) {
          this.showButton = response.data[0].totalItems > 50;
        }
        this.isFirst50Items = true;
      });
    },
    exportExcel() {
      this.loading = true;
      api
        .downloadReport(this.form)
        .then(response => {
          this.loading = false;
          var blob = response.data;
          var fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1];
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(blob, fileName);
          } else {
            var blobURL = window.URL.createObjectURL(blob);
            var tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", fileName);

            // Safari thinks _blank anchor are pop ups. We only want to set _blank
            // target if the browser does not support the HTML5 download attribute.
            // This allows you to download files in desktop safari if pop up blocking
            // is enabled.
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }

            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
          }
        })
        .catch(error => {
          this.loading = false;
        });
    },
    chooseAction(id, status) {
      this.claimId = id;
      this.claimStatus = status;
      this.chooseActionVisible = true;
    },
    viewClaim(id) {
      if (this.chooseActionVisible == true) {
        this.chooseActionVisible = false;
      }
      this.claimToView = id;
      this.previewClaimVisible = true;
    },
    editClaim(id) {
      if (this.chooseActionVisible == true) {
        this.chooseActionVisible = false;
      }
      this.claimToEdit = id;
      this.updateClaimVisible = true;
    },
    updateClaimFinished() {
      this.claimToEdit = undefined;
      this.updateClaimVisible = false;
    },
    previewClaimFinished() {
      this.claimToView = undefined;
      this.previewClaimVisible = false;
    },
    showClaimPreview(id) {
      this.claimToView = id;
      this.previewClaimVisible = true;
    },
    claimPublished() {
      this.$notify({
        title: this.$t('common.success'),
        message: this.$t('common.claimSuccesfullySubmitted'),
        type: "success"
      });
      this.loadClaims();
    },
    change(value) {
      switch (value) {
        case 0:
          this.form.isCanadian = true;
          this.form.isForCostco = false;
          break;
        case 1:
          this.form.isCanadian = true;
          this.form.isForCostco = true;
          break;
        case 2:
          this.form.isCanadian = false;
          this.form.isForCostco = false;
          break;
        case 3:
          this.form.isCanadian = false;
          this.form.isForCostco = true;
          break;
      }
    }
  }
};
</script>

<style scoped>
th,
td {
  font-size: 9px;
}
</style>
<style>
.custome-collapse-color {
  background-color: #ececec;
}
</style>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/Costco.vue